"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsSGUinfin = exports.isSGUinfin = void 0;
const sg_uinfin_1 = require("../../data/sg-uinfin");
const IsString_1 = require("../string/IsString");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function isSGUinfin(value, args, constraints) {
    const isStringResults = await (0, IsString_1.isString)(value, args, constraints);
    if (isStringResults.pass === false || isStringResults.skipped) {
        return isStringResults;
    }
    if (!(0, sg_uinfin_1.validateUinfin)(value)) {
        return { pass: false, message: `should be a valid NRIC/FIN` };
    }
    return { pass: true };
}
exports.isSGUinfin = isSGUinfin;
/**
 * Validates that this property is a valid NRIC/FUN
 */
function IsSGUinfin(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsSGUinfin",
        defaultMessage: `should be a valid NRIC/FIN`,
        options,
        constraints,
        validateFn: isSGUinfin,
    });
}
exports.IsSGUinfin = IsSGUinfin;
//# sourceMappingURL=IsSGUinfin.js.map